import React, { useState, useMemo, useEffect } from 'react'
import styles from './statistic-modal.module.scss'
import { confirm } from '../../UI/Confirm/Confirm'
import moment from 'moment'
import { billingStatus } from '../ProfileHeader/Services/utils'

export default function SendStatisticStepThree({
  onSend,
  onSkip,
  surveyData,
  onExploreServices,
  setPendingVacancyId,
  pendingVacancyId,
}) {
  const [selectedVacancy, setSelectedVacancy] = useState(null)
  const dateFormat = JSON.parse(localStorage.getItem('settings'))?.date_format || 'MMM YYYY'
  const vacancyOptions = useMemo(() => {
    if (surveyData && surveyData.vacancy_offers && surveyData.vacancy_offers.length > 0) {
      return surveyData.vacancy_offers.map((offer) => ({
        id: offer.vacancy_id,
        company: offer.company_name,
        rank: offer.rank_name,
        vesselType: offer.vacancy_type === 'sea' ? offer.vessel_type_name : offer.country_name,
        vacancyType: offer.vacancy_type,
        salary: offer.salary + offer.salary_currency_symbol,
        joinDate: offer.join_date,
        join_date_range: offer.join_date_range,
        originalData: offer,
      }))
    } else {
      return []
    }
  }, [surveyData])

  const isUserEditingProfile = () => {
    const currentPath = window.location.pathname

    const isOnProfileEditPage = currentPath.includes('/profile/edit/')

    if (!isOnProfileEditPage) {
      return false
    }

    const activeElement = document.activeElement
    if (
      activeElement &&
      (activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.contentEditable === 'true')
    ) {
      return true
    }

    const changedInputs = document.querySelectorAll(
      'input.changed, input[data-changed="true"], textarea.changed, textarea[data-changed="true"]'
    )
    const dirtyInputs = document.querySelectorAll(
      'input.dirty, input[data-dirty="true"], textarea.dirty, textarea[data-dirty="true"]'
    )
    const modifiedInputs = document.querySelectorAll('input.modified, textarea.modified, [data-modified="true"]')

    const saveButtons = document.querySelectorAll(
      'button[type="submit"]:not(:disabled), .save-button:not(:disabled), .submit-button:not(:disabled)'
    )
    const enabledSaveButtons = Array.from(saveButtons).filter(
      (btn) => btn.style.display !== 'none' && !btn.hasAttribute('disabled')
    )

    return (
      changedInputs.length > 0 || dirtyInputs.length > 0 || modifiedInputs.length > 0 || enabledSaveButtons.length > 0
    )
  }

  const hasSelection = selectedVacancy !== null

  const handleExploreServices = () => {
    const isEditing = isUserEditingProfile()

    if (isEditing) {
      if (document.getElementById('confirm')) {
        return
      }

      confirm(
        'Are you sure you want to proceed?',
        'You have unfinished business.',
        () => {
          onExploreServices()
        },
        () => {
          return
        }
      )
    } else {
      onExploreServices()
    }
  }

  const handleVacancySelect = (vacancy) => {
    if (selectedVacancy && selectedVacancy.id === vacancy.id) {
      setPendingVacancyId(null)
      setSelectedVacancy(null)
    } else {
      setPendingVacancyId(vacancy.id)
      setSelectedVacancy(vacancy)
    }
  }

  const handleSend = () => {
    if (selectedVacancy) {
      onSend({
        vacancy_id: selectedVacancy.id,
        vacancy_data: selectedVacancy.originalData,
      })
    }
  }
  useEffect(() => {
    return () => setPendingVacancyId(null)
  }, [])
  return (
    <div className={styles['statisticStepThree']}>
      <div className={styles['statisticStep__header']}>
        <span className={styles['statisticStep__icon']}>🎉</span>
        <b>Great to Hear! Help Us Improve</b>
        <span className={styles['statisticStep__icon']}>🚢</span>
      </div>

      <p>
        We’re glad you’ve found a job! To help us improve our services and provide better opportunities for other
        seafarers, could you let us know where you applied?
      </p>

      <div className={styles['statisticStep__instruction']}>
        <span className={styles['statisticStep__diamond']}>🔹</span>
         Select the company you got hired by from the list below.
      </div>

      <div className={styles['statisticStep__companies']}>
        {vacancyOptions && vacancyOptions.length > 0 ? (
          vacancyOptions.map((vacancy) => (
            <button
              key={vacancy.id}
              onClick={() => handleVacancySelect(vacancy)}
              className={`${styles['statisticStep__company']} ${
                selectedVacancy && selectedVacancy.id === vacancy.id
                  ? `${styles['statisticStep__company--selected']} ${styles['statisticStep__company--active']}`
                  : ''
              }`}
            >
              <div className={styles['statisticStep__company-header']}>
                <div className={styles['statisticStep__company-name']}>{vacancy.company}</div>
                <div className={styles['statisticStep__company-salary']}>{vacancy.salary}</div>
              </div>
              <div className={styles['statisticStep__company-details']}>
                <span className={styles['statisticStep__company-rank']}>{vacancy.rank}</span>
                <span
                  className={
                    vacancy.vacancyType === 'sea'
                      ? styles['statisticStep__company-vessel']
                      : styles['statisticStep__company-country']
                  }
                >
                  {vacancy.vesselType}
                </span>
                {vacancy.join_date_range ? (
                  <time dateTime={vacancy.joinDate} className={styles['statisticStep__company-date']}>
                    {vacancy.join_date_range.toUpperCase()}{' '}
                    {moment(vacancy.joinDate).local('en').format('MMM YYYY') || '–'}
                  </time>
                ) : (
                  <time dateTime={vacancy.joinDate} className={styles['statisticStep__company-date']}>
                    {moment(vacancy.joinDate).local('en').format(dateFormat) || '–'}
                  </time>
                )}
              </div>
            </button>
          ))
        ) : (
          <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
            {surveyData && surveyData.vacancy_offers && surveyData.vacancy_offers.length === 0 ? 'No vacancies available' : 'Loading vacancies...'}
          </div>
        )}
      </div>

      <div className={styles['statisticStep__buttons']}>
        {hasSelection ? (
          <button onClick={handleSend} className={styles['statisticStep__button--primary-full']}>
            Send
          </button>
        ) : (
          <div className={`${styles['statisticStep__buttons']} ${styles['statisticStep__buttons_column']}`}>
            {billingStatus() && (
              <button onClick={handleExploreServices} className={styles['statisticStep__button']}>
                Explore services
              </button>
            )}

            <button onClick={onSkip} className={styles['statisticStep__button--skip-full']}>
              Skip
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
